import React, {Component} from 'react'
import cn from "classnames"
import injectSheet from 'react-jss'
import Section from '../Widgets/Section'

class Author extends Component {

    render() {
        const {classes, author} = this.props;

        return (
            <Section className={classes.root}>
                {author && (
                    <div className={cn(classes.container)}>
                        {author.image && <img src={author.image.desktop[0].url} alt={author.image.alt} className={classes.image} />}
                        <div className={classes.title}>{author.name}</div>
                        {author.title && <div>{author.title}</div>}
                        <div className={classes.divider} />
                    </div>
                )}
            </Section>
        )
    }
}

export default injectSheet((theme) => (
    {
        root: {
            marginBottom: theme.spacing.large
        },
        container: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: theme.colors.assent,
            fontWeight: theme.font.info.fontWeight,
            lineHeight: theme.getRemValue(18),
            fontSize: theme.getRemValue(12),
            marginBottom: 0,
            [theme.breakpoint("tablet")]: {
              fontSize: theme.getRemValue(12)
            }
        },
        divider: {
            width: '100%',
            height: 1,
            backgroundColor: theme.colors.faintGrey,
            marginTop: theme.spacing.large
        },
        title: {
            fontWeight: "normal",
            color: theme.colors.black
        },
        image: {
            width: 64,
            height: 64,
            borderRadius: "50%",
            marginBottom: 14,
            [theme.breakpoint("tablet")]: {
              width: 72,
              height: 72
            }
        }
    }
))(Author)





// WEBPACK FOOTER //
// ./src/components/Widgets/Author.js